import { render } from "./IndustryBadge.vue?vue&type=template&id=44e02da8&scoped=true"
import script from "./IndustryBadge.vue?vue&type=script&lang=js"
export * from "./IndustryBadge.vue?vue&type=script&lang=js"

import "./IndustryBadge.vue?vue&type=style&index=0&id=44e02da8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e02da8"]])

export default __exports__